export class NavOnboardingTourError extends Error {
  constructor(...args) {
    super(...args);
    this.name = 'NavOnboardingTourError';
  }
}